(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const openBtn = document.querySelector(".header__offcanvas-toggle");
		const openBtnTrigger = openBtn?.querySelector(
			".header__offcanvas-toggle-link",
		);
		const closeBtn = document.querySelector(
			".header__offcanvas-toggle-link--close",
		);
		const offMenu = document.querySelector(".header__offcanvas-menu");
		const searchDetails = document.querySelector(".header__details");
		const submenuDetails = document.querySelectorAll(
			".header__submenu li details",
		);
		const openSearchBtn = document.querySelector(".header__search");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";
		const headerIsSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "on-scroll-up";
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");

		const openMenu = (e) => {
			e.preventDefault();
			offMenu.classList.add("header__offcanvas-menu--open");
			if (openBtn) openBtn.classList.add("active");
			if (openBtnTrigger) openBtnTrigger.setAttribute("aria-expanded", "true");
			body.classList.add("body--hidden");
			trapFocus(offMenu, closeBtn || openBtnTrigger);
		};

		const closeMenu = (returnFocus = true) => {
			offMenu.classList.remove("header__offcanvas-menu--open");
			if (openBtn) openBtn.classList.remove("active");
			if (openBtnTrigger) openBtnTrigger.setAttribute("aria-expanded", "false");
			body.classList.remove("body--hidden");
			removeTrapFocus(returnFocus ? openBtnTrigger : null);
		};

		if (openBtnTrigger)
			openBtnTrigger.addEventListener("click", openMenu);
		if (closeBtn)
			closeBtn.addEventListener("click", function (e) {
				e.preventDefault();
				closeMenu();
			});

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener("click", () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open");
					}
				});
			});
		});

		document.addEventListener("keyup", (e) => {
			let scrollTop = window.scrollY;
			if (e.key === "Escape") {
				closeMenu();
				body.classList.remove("overflow-hidden");
				if (
					searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsSticky
				) {
					header.classList.remove(
						"animate",
						"animated",
						"shopify-section-header-sticky",
					);
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsAlwaysSticky
				) {
					header.classList.remove("animate", "animated");
					header.classList.add("shopify-section-header-sticky");
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					scrollTop > header.offsetHeight / 2 &&
					(headerIsSticky || headerIsAlwaysSticky)
				) {
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					!headerIsAlwaysSticky &&
					!headerIsSticky
				) {
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
					searchDetails.removeAttribute("open");
				}
			}
		});

		if (openSearchBtn) {
			openSearchBtn.addEventListener("click", () => {
				let scrollTop = window.scrollY;
				if (searchDetails.open && headerIsAlwaysSticky) {
					body.classList.add("overflow-hidden");
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
					);
				} else if (searchDetails.open && !headerIsAlwaysSticky) {
					body.classList.add("overflow-hidden");
					header.classList.add("shopify-section-header-sticky", "animate");
				} else if (
					!searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsSticky
				) {
					body.classList.remove("overflow-hidden");
					header.classList.remove(
						"animate",
						"animated",
						"shopify-section-header-sticky",
					);
				} else if (
					!searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsAlwaysSticky
				) {
					body.classList.remove("overflow-hidden");
					header.classList.remove("animate", "animated");
				} else if (
					!searchDetails.open &&
					scrollTop > header.offsetHeight / 2 &&
					(headerIsSticky || headerIsAlwaysSticky)
				) {
					body.classList.remove("overflow-hidden");
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
				} else if (
					!searchDetails.open &&
					!headerIsAlwaysSticky &&
					!headerIsSticky
				) {
					body.classList.remove("overflow-hidden");
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
				} else {
					body.classList.remove("overflow-hidden");
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
				}
			});
		}

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;

			if (scrollTop > header.offsetHeight / 2 && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		let scrollTop = window.scrollY;

		if (scrollTop > header.offsetHeight / 2 && headerIsAlwaysSticky) {
			header.classList.add("fixed", "animate");
		} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
			header.classList.remove("fixed", "animate");
		}

		const getScrollTop = () => window.scrollY

		megaMenuLinks.forEach((link) => {
			const isMegaSubmenu = link.classList.contains('list-menu--megasubmenu');

			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");

				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--megamenu-visible");
					if (!isMegaSubmenu &&getScrollTop() <= header.offsetHeight / 2) {
						header.classList.add('shopify-section-header-sticky', 'animate')
					}
				});

				link.addEventListener("mouseleave", () => {
					setTimeout(() => {
						link.classList.remove("list-menu--megamenu-visible");
						if (!isMegaSubmenu && getScrollTop() <= header.offsetHeight / 2) {
							header.classList.remove(
								'shopify-section-header-sticky',
								'animate',
							)
						};
					}, 300);
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--megamenu-visible");
						if (!isMegaSubmenu && getScrollTop() <= header.offsetHeight / 2) {
							header.classList.add('shopify-section-header-sticky', 'animate')
						}
					});
				});
			});
		});

		initMegaSubmenu(header)
	};

	const initMegaSubmenu = (header) => {	
		const megaSubmenuLinks = header.querySelectorAll('.list-menu--megasubmenu')
		if (!megaSubmenuLinks || !megaSubmenuLinks.length) return
		megaSubmenuLinks.forEach((link) => {
			const tablist = link.querySelector('.mega-submenu__tabs')
			if (!tablist) return
			const tabs = Array.from(link.querySelectorAll('.mega-submenu__tab[role="tab"]'))
			const submenus = link.querySelectorAll('.mega-submenu__submenu[role="tabpanel"]')

			const activateTab = (tab) => {
				if (!tab) return
				const tabId = tab.dataset.tabId
				tabs.forEach((item) => {
					const isActive = item === tab
					item.classList.toggle('active', isActive)
					item.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})
				submenus.forEach((submenu) => {
					const isActive = submenu.dataset.tabId === tabId
					submenu.classList.toggle('active', isActive)
					if (isActive) {
						submenu.removeAttribute('hidden')
					} else {
						submenu.setAttribute('hidden', '')
					}
				})
			}

			const onToggle = (event) => {
				const tab = event.target.closest('.mega-submenu__tab')
				if (!tab || !tablist.contains(tab)) return
				if (event.type === 'click' && tab.tagName === 'A') return
				event.preventDefault()
				activateTab(tab)
			}

			tabs.forEach((tab) => {
				tab.addEventListener('click', onToggle)
				tab.addEventListener('mouseenter', onToggle)
				tab.addEventListener('focus', onToggle)
			})

			tablist.addEventListener('keydown', (event) => {
				const currentIndex = tabs.indexOf(document.activeElement)
				if (currentIndex === -1) return

				let nextIndex = currentIndex
				if (event.code === 'ArrowRight' || event.code === 'ArrowDown') {
					event.preventDefault()
					nextIndex = (currentIndex + 1) % tabs.length
				} else if (event.code === 'ArrowLeft' || event.code === 'ArrowUp') {
					event.preventDefault()
					nextIndex = (currentIndex - 1 + tabs.length) % tabs.length
				} else if (event.code === 'Home') {
					event.preventDefault()
					nextIndex = 0
				} else if (event.code === 'End') {
					event.preventDefault()
					nextIndex = tabs.length - 1
				} else {
					return
				}

				tabs[nextIndex].focus()
				activateTab(tabs[nextIndex])
			})
		})
	}

	document.addEventListener("shopify:section:load", header);

	header();
})();
